<template>
  <div class="page__container">
    <navigation-bar :showNavigationItems="true" :showMyAccountIcon="true" />
    <div class="page__content-container news__container">
      <div class="video__wrapper" v-if="newsItem.youtube_id">
        <iframe
          class="video__item"
          width="640"
          height="480"
          :src="`https://www.youtube-nocookie.com/embed/${newsItem.youtube_id}`"
          frameborder="0"
          allow="autoplay; encrypted-media; picture-in-picture;"
          allowfullscreen
        ></iframe>
      </div>
      <div class="news__carousel" v-if="!newsItem.youtube_id">
        <div
          class="news__carousel-image"
          v-for="img in newsItem.images"
          :key="img.id"
        >
          <responsive-img
            class="news__items-image"
            :imgId="img.id"
            :imgType="'newsImage'"
            :imgAlt="img.alt"
          />
        </div>
      </div>
      <div class="news__title-date__wrapper">
        <h1 class="news__title">{{ newsItem.title }}</h1>
        <span class="news__date">{{
          date.format(new Date(newsItem.created), "DD-MM-YYYY")
        }}</span>
      </div>
      <p class="page__content-text" style="text-align: justify" v-html="newsItem.text">
      </p>
    </div>
    <footer-component />
  </div>
</template>


<script>
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/Footer.vue";
import ResponsiveImg from "@/components/ResponsiveImg.vue";

import date from "date-and-time";
import { useRoute } from "vue-router";
import { ref } from "vue";
import axios from "axios";

export default {
  components: { NavigationBar, FooterComponent, ResponsiveImg },
  setup() {
    const route = useRoute();
    const { slug } = route.params;

    const newsItem = ref({});

    const get = async () => {
      try {
        const { data } = await axios({
          url: `/api/news/${slug}`,
          method: "GET",
          withCredentials: true,
        });

        newsItem.value = data;
      } catch ({ response, message }) {
        console.log({ response, message });
      }
    };

    get();

    return {
      newsItem,
      date,
    };
  },
};
</script>
